module.exports = __webpack_public_path__ + "img/wa-chat-icon.def3d653.svg";